var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapsPinCallBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 38,
    viewBox: "0 0 22 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_728_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.18218 3.94954C1.59108 5.64764 0.59447 8.12129 0.633168 10.448C0.713977 15.3102 2.90561 17.1508 6.41043 23.8426C7.67293 26.7873 8.9906 29.9032 10.2438 35.0637C10.418 35.8249 10.5878 36.532 10.6664 36.5933C10.7449 36.6546 10.9148 35.945 11.089 35.1838C12.3422 30.0232 13.6599 26.9099 14.9224 23.9652C18.4272 17.2733 20.6188 15.4327 20.6997 10.5705C20.7384 8.24379 19.7393 5.76766 18.1482 4.06956C16.3306 2.12977 13.5892 0.694173 10.6664 0.634142C7.74368 0.574072 4.99975 2.00974 3.18218 3.94954Z",
    fill: "#4F2A70",
    stroke: "#1F112D",
    strokeWidth: 1.26462
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6664 14.4675C12.7865 14.4675 14.5052 12.7489 14.5052 10.6288C14.5052 8.50867 12.7865 6.79001 10.6664 6.79001C8.54634 6.79001 6.82764 8.50867 6.82764 10.6288C6.82764 12.7489 8.54634 14.4675 10.6664 14.4675Z",
    fill: "#1F112D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_728_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3333,
    height: 37.2185,
    fill: "white",
    transform: "translate(-0.000244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapsPinCallBack);
export default __webpack_public_path__ + "static/media/maps-pin-CallBack.092a5e3e1e2aba70233de1515814906c.svg";
export { ForwardRef as ReactComponent };